import { SimpleStatusRequestUpdateSimpleStatusRequestItems, MeetingStatusClient, MeetingStatusResponse } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import { tryCatchJsonByAction } from 'utils/fetchUtils';
import store from 'base/reducer/store';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';

export const getMeetingMinutesStatusesAction = () => {
	const tenantId = getTenantId()!;
	const client = new MeetingStatusClient();
	return client.getAll(tenantId);
}

export const updateMeetingMinutesStatusesAction = (model: SimpleStatusRequestUpdateSimpleStatusRequestItems) => {
	const tenantId = getTenantId()!;
	const client = new MeetingStatusClient();
	return client.update(tenantId, model);
}

export const persistMeetingStatusesAction = async () => {
	const state = store.getState();

	if (state.persistedMeetingStatus.fetching) {
		return;
	}

	store.dispatch(setFetchingAction(true));

	const response = await tryCatchJsonByAction(getMeetingMinutesStatusesAction);
	if (response.success) {
		store.dispatch(setAction(response.items || []));
	} else {
		store.dispatch(setFetchingAction(false));
	}
}

// redux

export const MEETING_STATUS_FETCHING = 'MEETING_STATUS_FETCHING';
export const MEETING_STATUS_SET = 'MEETING_STATUS_SET';

const setFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: MEETING_STATUS_FETCHING,
		fetching
	}
}

const setAction = (items: MeetingStatusResponse[]): PersistItemsActionType<MeetingStatusResponse> =>  {
	return {
		type: MEETING_STATUS_SET,
		items
	}
}
